import classNames from 'classnames';
import { useContext } from 'react';

import { Button, ButtonVariant, Icon, Typography } from '@/shared/ui';

import AccessibilityContext from '@/contexts/AccessibilityContext';

import './AccessibilityPanelButtonStyles.scss';

interface Props {
  color?: 'blue' | 'white';
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export const AccessibilityPanelButton: React.FC<Props> = ({ onClick, color = 'white' }) => {
  const { isPanelShown, turnOnAccessibilityPanel } = useContext(AccessibilityContext);

  const buttonColor = isPanelShown ? 'yellow' : color;

  return (
    <Button
      variant={ButtonVariant.ICON_GHOST}
      onClick={(e): void => {
        turnOnAccessibilityPanel(e);
        onClick && onClick(e);
      }}
      className={classNames('custom-accessibility-button', `custom-accessibility-button--${buttonColor}`)}
    >
      <Icon className="custom-accessibility-button__icon" name="accessibility_off" />
      <Typography className="custom-accessibility-button__text">Доступність</Typography>
    </Button>
  );
};
